/* eslint-disable */
import mongoose, { Schema } from 'mongoose';
import {
  always,
  applySpec,
  compose,
  converge,
  nthArg,
  propOr,
} from 'ramda';
import uuid from 'uuid/v4';
import { string } from '@555platform/utility-belt.js';
import { renameObjectKeys } from '../util';
import { query as queryModel } from './util';

const now = () => new Date();

const TokenExchangeSchema = new Schema({
  className: {
    type: String,
    default: 'TokenExchange',
  },
  readAccess: {
    type: [
      { type: String },
    ],
    default: ['*'],
  },
  writeAccess: {
    type: [
      { type: String },
    ],
    default: ['*'],
  },
  ownerID: {
    type: String,
    default: '',
  },
  createAt: {
    type: Date,
    default: now,
  },
  updatedAt: {
    type: Date,
    default: now,
  },
  fields: {
    objectID: {
      type: String,
      default: () => uuid(),
    },
    app_key: {
      type: String,
      default: '',
      required: true,
    },
    current_alg: {
      type: String,
      default: 'RS256',
      required: true,
    },
    public_key_text: {
      type: String,
      default: '',
      required: true,
    },
    unique_id_claim: {
      type: String,
      default: '',
      required: true,
    },
  },
});

// NOTE: AUM service will ensure indexeds
export const TokenExchangeModel = () => mongoose.model(
  'tokenexchange',
  TokenExchangeSchema,
  'TokenExchange',
);

export const query = queryModel(TokenExchangeModel);

const applyFieldScope = string.createTemplate('fields.${}');

TokenExchangeSchema.statics.findByAppKey = compose(
  query('findOne'),
  applySpec({
    'fields.app_key': nthArg(0),
    ownerID: nthArg(1),
  }),
);

TokenExchangeSchema.statics.upsert = converge(
  query('findOneAndUpdate'),
  [
    applySpec({ 'fields.app_key': propOr('__', 'app_key') }),
    applySpec({
      updatedAt: now,
      $setOnInsert: { ownerID: nthArg(1), createdAt: now },
      $set: renameObjectKeys(applyFieldScope),
    }),
    always({
      upsert: true,
      setDefaultsOnInsert: true,
      new: true,
    }),
  ],
);

export default TokenExchangeModel;
